export default {
  bacs: 'BACS',
  fps: 'FPS',
  bureau: 'BACS Bureau',
  collections: 'Collections',
  bacsOnline: 'BACS Online',
  fpsOnline: 'FPS Online'
}
